import { Component, EventEmitter, Input, OnInit, Output, ViewContainerRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';
import { UserService } from '../../pages/com.usblick.common/auth/user.service';

@Component({
  selector: 'usb-head-band',
  templateUrl: './head-band.component.html',
  styleUrls: ['./head-band.component.scss'],
  providers: [DatePipe]
})
export class HeadBandComponent implements OnInit {

  @Input() getClientsSettingAppBooking: any;
  @Input() payloadSearch: any;
  @Input() formTransports: any;
  @Input() _actualItinerary: any;
  @Input() openModalFly: boolean = false;
  @Output() updateFlyEmitter = new EventEmitter<any>();
  modalRef: BsModalRef;
  itinerary$: Observable<any[]>;


  constructor(
    public vcr: ViewContainerRef,
    public userService:UserService
  ) {
  }

  ngOnInit() {}


  _backToMain() {
    if (this.modalRef !== undefined) {
      this.modalRef.hide();
    }
    window.history.back();
  }

  updateFly(event: boolean): void {
    this.updateFlyEmitter.emit();
  }
}
